import {
    LOCATION_UID_KEY,
    PHONE_TYPE_MAIN,
    WEBSITE_TYPE_HOMEPAGE,
    BUSINESS_HOURS_TYPE_MAIN,
    PROFILE_PLACES_PREFIX,
} from 'directory/listings/notification-modals/constants';
import {
    Patch,
    PatchMap,
    PatchOperation,
    LocationDataRow,
    FieldType,
} from 'directory/listings/notification-modals/types';

const DAY_MAP: Record<string, string> = {
    Monday: 'monday',
    Tuesday: 'tuesday',
    Wednesday: 'wednesday',
    Thursday: 'thursday',
    Friday: 'friday',
    Saturday: 'saturday',
    Sunday: 'sunday',
};

const FIELD_TRANSFORMERS: Record<FieldType, (data: any) => PatchMap> = {
    PHONE_NUMBER: (phoneData: string): PatchMap => ({
        [`${PROFILE_PLACES_PREFIX}profile_phone__0_type`]: PHONE_TYPE_MAIN,
        [`${PROFILE_PLACES_PREFIX}profile_phone__0_number`]: phoneData,
    }),
    WEBSITE_LINK: (websiteData: string): PatchMap => ({
        [`${PROFILE_PLACES_PREFIX}profile_website__0_type`]: WEBSITE_TYPE_HOMEPAGE,
        [`${PROFILE_PLACES_PREFIX}profile_website__0_url`]: websiteData,
    }),
    BUSINESS_HOURS: (businessHoursData: any[]): PatchMap => {
        const patchMap: PatchMap = {
            [`${PROFILE_PLACES_PREFIX}profile_business_hr__0_type`]: BUSINESS_HOURS_TYPE_MAIN,
        };

        businessHoursData.forEach((dayData) => {
            const { day, hours } = dayData;
            const fieldKey = DAY_MAP[day];

            if (fieldKey) {
                const formattedHours = hours === 'Closed' ? 'Closed' : hours.replace(' - ', '-');

                patchMap[`${PROFILE_PLACES_PREFIX}profile_business_hr__0_${fieldKey}`] = formattedHours;
            }
        });

        return patchMap;
    },
    DESCRIPTION: (descriptionData: string): PatchMap => ({
        __profile_description__: descriptionData,
    }),
    UNKNOWN: (): PatchMap => ({}),
};

export const transformRowToPatch = (row: LocationDataRow): Patch | null => {
    const { locationUid, googleData, field } = row;

    if (!googleData || !field || field === 'UNKNOWN') {
        return null;
    }

    const transformer = FIELD_TRANSFORMERS[field];

    if (!transformer) {
        return null;
    }

    const fieldPatchMap = transformer(googleData);

    const patchMap: PatchMap = {
        [LOCATION_UID_KEY]: locationUid.toString(),
        ...fieldPatchMap,
    };

    return {
        patchMap,
        patchOperation: PatchOperation.Update,
    };
};

export const transformRowsToPatches = (rows: LocationDataRow[]): Patch[] => {
    return rows.map(transformRowToPatch).filter((patch): patch is Patch => patch !== null);
};
